import type { DividerProps } from './const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function Divider(props: DividerProps, ref: React.Ref<HTMLDivElement>) {
  const {
    style,
    className = '',
    variant = 'dashed',
    children,
    plain = false,
    direction = 'horizontal',
    theme = 'dark',
    lineStyle,
    lineClassName,
    contentStyle,
    contentClassName,
  } = props;

  const Line = (
    <div
      className={cn('wg-divider__line', {
        'wg-divider__line--dashed': variant === 'dashed',
        'wg-divider__line--solid': variant === 'solid',
        'wg-divider__line--light': theme === 'light',
        'wg-divider__line--dark': theme === 'dark',
      }, lineClassName)}
      style={lineStyle}
    />
  );

  return (
    <div
      ref={ref}
      className={cn('wg-divider', {
        'wg-divider--plain': plain,
        'wg-divider--vertical': direction === 'vertical',
        'wg-divider--light': theme === 'light',
        'wg-divider--dark': theme === 'dark',
      }, className)}
      style={style}
    >
      {Line}
      {children && (
        <>
          <div
            className={cn('wg-divider__content', contentClassName)}
            style={contentStyle}
          >
            {children}
          </div>
          {Line}
        </>
      )}
    </div>
  );
}

const DividerComponent = forwardRef<HTMLDivElement, DividerProps>(Divider);
DividerComponent.displayName = 'Divider';

export default DividerComponent;

export type { DividerProps };
